<template>
    <div class="top-[var(--app-header-height)]">
        <Breadcrumbs
            v-if="crumbs && crumbs.length"
            :crumbs="crumbs"
            class="z-20 py-3 px-6"
            :useBackButton="useBackButton"
            :backButtonUrl="backButtonUrl"
        />
        <AppSectionHeader
            v-else-if="title"
            :title="title"
            class="z-20 font-medium"
            :useBackButton="useBackButton"
            :backButtonUrl="backButtonUrl"
            :subTitle="subTitle"
        />
        <div class="relative w-full h-full flex">
            <aside
                class="z-10 shrink-0 flex flex-col w-[var(--app-left-aside-width)] border-r border-keyline-primary sticky table-sticky-top"
                :class="{ 'new_aside_height': !supressFullHeight }"
            >
                <slot name="aside"></slot>
            </aside>
            <div
                :class="{ '!overflow-hidden': inert, 'pb-24': !paddedBottom }"
                class="z-0 relative overflow-x-auto grow h-[calc(100vh_-_var(--header-height))]"
                id="main-scroll-container"
                @scroll="handleLeftAsideScroll"
            >
                <LoadingProgress :is-loading="inert">
                    <slot name="default"></slot>
                </LoadingProgress>
                <div 
                    v-if="scrollTop > 0 && useScrollShadow"
                    class="shadow-scroll-inset"
                ></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {AppSectionHeader, LoadingProgress, Breadcrumbs} from "@/Components";
import { ref } from 'vue';
defineProps(['title', 'useBackButton', 'backButtonUrl', 'supressFullHeight', 'useScrollShadow', 'crumbs', 'subTitle', 'paddedBottom']);

const scrollTop = ref(0);

const handleLeftAsideScroll = (e) => {
    scrollTop.value = e.target.scrollTop;
};
</script>

<style scoped>
.shadow-scroll-inset {
    position: fixed;
    top: calc(var(--header-height) - 1px);
    left: calc(var(--app-left-aside-width) + var(--app-main-nav-width));
    right: 0;
    height: 22px;
    pointer-events: none;
    z-index: 50;
}
</style>
